export default __webpack_public_path__ + "static/media/banner-back.bcd5cf1e.svg";